module.exports = __webpack_public_path__ + "static/media/notification_bell.a8740a19.png";